import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgPaymentIconSecondary from './svgs/PaymentIconSecondary.js';
import SvgPaymentIcon from './svgs/PaymentIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var paymentIcon = (props => useIcon(SvgPaymentIcon, SvgPaymentIconSecondary, props));

export { paymentIcon as default };
